package ui.new_ui.components.card_item

import ui.new_ui.color_scheme.MainColorScheme
import ui.new_ui.requirements.MinRequirements
import web.cssom.*

object CardStyles: MinRequirements {
    val borderRadius = 6.px
    val margin = Margin(horizontal = 10.px, vertical = 4.px)
    val padding = Padding(horizontal = 10.px, vertical = 4.px)

    fun backgroundColor() = MainColorScheme.SecondaryColors.secondaryColorContainer()
    fun color() = MainColorScheme.SecondaryColors.secondaryColorOnContainer()

    object Shadow {
        fun shadowColor() = MainColorScheme.BackgroundColors.backgroundColorOnContainer()
        val shadowSpreadRadius = 0.px
        val shadowBlurRadius = 3.px
    }
}